import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const OHeroEditorialContainer = styled.div`
  .oheroeditorial-wrapper {
    width: 100%;
    gap: ${toRem(32)};
    margin-top: ${toRem(16)};

    @media ${baseVariables.mediaQuery.lg} {
      gap: ${toRem(48)};
    }
  }
`;
